import {AthleteProfileTeaserProps} from "@/components/page-teaser/athlete-page-teaser/types";

export function AthletePageTeaser({ profiles, hideImages }: {
    profiles: AthleteProfileTeaserProps[],
    hideImages?: boolean
}) {

    return (
        <section className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {profiles?.map((profile) => (
                <div key={profile.linkURL} className={"h-full flex flex-col border border-neutralNsf-subtle"}>
                    {!hideImages && (
                        <div className={"w-full"}>
                            <div className={"aspect-square overflow-hidden"}>
                                <img className={"size-full object-center object-cover"}
                                     src={profile.profileImage}
                                     alt={profile.photoCredit}
                                />
                            </div>
                        </div>
                    )}
                    <div className={"flex flex-col gap-3 p-4 h-full"}>

                        <div className={"flex flex-col gap-2 "}>
                            <h3 className={"mb-0"}>{profile.pageName}</h3>
                        </div>
                        <ul className="text flex flex-col gap-y-1">
                            {profile.jobTitle &&
                                <li>Stilling: <span className={"font-semibold"}>{profile.jobTitle}</span></li>}
                            {profile.residentTown &&
                                <li>Bosted: <span className={"font-semibold"}>{profile.residentTown}</span></li>}
                            {profile.shortDateOfBirth &&
                                <li>Født: <span className={"font-semibold"}>{profile.shortDateOfBirth}</span></li>}
                            {profile.phonenumber &&
                                <li>Telefon: <span className={"font-semibold"}>{profile.phonenumber}</span></li>}
                            {profile.club && <li>Klubb: <span className={"font-semibold"}>{profile.club}</span></li>}
                            {profile.team && profile.team.length > 2 &&
                                <li className={"font-semibold"}>{profile.team}</li>}
                            {profile.email &&
                                <li><a href={`mailto:${profile.email}`} target="_blank">Send e-post</a></li>}
                            {profile.profileImage &&
                                <li><a href={profile.profileImage} target="_blank">Last ned bilde</a></li>}
                            {profile.photoCredit &&
                                <li>Foto: <span className={"font-semibold"}>{profile.photoCredit}</span></li>}
                        </ul>
                    </div>
                    <div className={"flex flex-col gap-2 items-end justify-end p-4 "}>
                        {profile.externalURL && (profile?.fisAthleteId ?? 0) >= 0 && profile.fisAthleteSectorValue && (
                            <a
                                href={`${profile.externalURL}?sector=${profile.fisAthleteSectorValue}&competitorid=${profile.fisAthleteId}`}
                                target="_blank">
                                FIS-biografi
                            </a>
                        )}
                        {profile.profilePage && (
                            <div>
                                {"Se profil: "}
                                <a href={profile.profilePage}>
                                    {profile.pageName}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </section>
    )
}